// Module
var code = `<div class="modal-dialog" role="document">
    <form data-bind="submit: continueSetup">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-bind="click: close" aria-hidden="true">
                    <i class="icon-cancel"></i>
                </button>
                <h4 class="modal-title">Your RavenDB instance is almost ready!</h4>
            </div>
            <div class="modal-body">
                <p>
                    RavenDB has generated a <strong>client certificate</strong> for you. 
                    Please unzip the downloaded file and <strong>install this certificate before restarting the server</strong>. <br>
                    When the server is restarted, you will be redirected to RavenDB Studio.<br>
                    Provide the client certificate to your browser as requested.
                </p>
                
                <p>Thank you for choosing RavenDB!</p>

                <div class="toggle" data-bind="validationOptions: { insertMessages: false }">
                    <input id="certInstalled" type="checkbox" data-bind="checked: certificateInstalled">
                    <label for="certInstalled">I've installed the client certificate</label>
                </div>
                <div data-bind="validationElement: certificateInstalled">
                    <div class="help-block" data-bind="validationMessage: certificateInstalled"></div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="flex-horizontal">
                    <small>
                        <i class="icon-info"></i>
                        Having troubles with installation?
                        Check out our
                        <a target="_blank" data-bind="attr: { href: documentationLink }">documentation</a>.
                    </small>
                    <div class="flex-separator"></div>
                    <button type="submit" class="btn btn-default">Continue</button>
                </div>
            </div>
        </div>
    </form>
</div>
`;
// Exports
export default code;